export const getTagTemplates = (i18n, isSpaEnabledForUet) => ({
  UET: [
    '<script>',
    '    (function(w,d,t,r,u)',
    '    {',
    '        var f,n,i;',
    '        w[u]=w[u]||[],f=function()',
    '        {',
    `            var o={ti:"{{tagId}}"${isSpaEnabledForUet ? ', enableAutoSpaTracking: true' : ''}};`,
    '            o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")',
    '        },',
    '        n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function()',
    '        {',
    '            var s=this.readyState;',
    '            s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)',
    '        },',
    '        i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)',
    '    })',
    '    (window,document,"script","//bat.bing.com/bat.js","uetq");',
    '</script>',
  ],
  UETExample: [
    '<!DOCTYPE html>',
    '<html lang="en">',
    '<head>',
    `{{highlighted}}//${i18n.getString(_TL_('Your tag goes here'))}{{/highlighted}}`,
    '</head>',
  ],
  PageLoadEventTagExample: [
    '<!DOCTYPE html>',
    '<html lang="en">',
    '<head>',
    '',
    `{{highlighted}}//${i18n.getString(_TL_('UET tag goes here.'))}{{/highlighted}}`,
    '',
    `{{highlighted}}//${i18n.getString(_TL_('Copy and paste the event tag right after UET tag.'))}{{/highlighted}}`,
    '    <script>',
    '            window.uetq = window.uetq || [];',
    '            window.uetq.push(\'event\', \'{{EventAction}}\', {{EventProperties}});',
    '    </script>',
    '',
    '</head>',
  ],
  InlineActionEventTagExample: [
    '<!DOCTYPE html>',
    '<html lang="en">',
    '<head>',
    '',
    `{{highlighted}}//${i18n.getString(_TL_('UET tag goes here.'))}{{/highlighted}}`,
    '',
    `{{highlighted}}//${i18n.getString(_TL_('Copy and paste the event tag right after UET tag.'))}{{/highlighted}}`,
    '    <script>',
    '        function {{highlighted}}uet_report_conversion(){{/highlighted}}',
    '        {',
    '            window.uetq = window.uetq || [];',
    '            window.uetq.push(\'event\', \'{{EventAction}}\', {{EventProperties}});',
    '        }',
    '    </script>',
    '',
    '   </head>',
    '<body>',
    `{{highlighted}}//${i18n.getString(_TL_('In the button code you want to track, call the function name from event tag.'))}{{/highlighted}}`,
    `    <button id="purchaseConfirmation" onclick="{{highlighted}}uet_report_conversion(){{/highlighted}}">${i18n.getString(_TL_('Sign Up Now'))}</button>`,
    '</body>',
  ],
  PageLoadEventSnippet: [
    '<script>',
    '     window.uetq = window.uetq || [];',
    '     window.uetq.push(\'event\', \'{{EventAction}}\', {{EventProperties}});',
    '</script>',
  ],
  InlineEventSnippet: [
    '<script>',
    'function uet_report_conversion() {',
    '     window.uetq = window.uetq || [];',
    '     window.uetq.push(\'event\', \'{{EventAction}}\', {{EventProperties}});',
    '}',
    '</script>',
  ],
  UETTagInstructions: [
    i18n.getString(_TL_('Copy the tag and paste it in between the <head></head> tags of every page of your website.')),
    i18n.getString(_TL_('You only need to install the global site tag once on every page of your website, even if you are tracking multiple conversions.')),
    i18n.getString(_TL_('You can also {{a}}{{/a}} if not sure how to do it manually.')),
  ],
  InlineEventTagInstructions: [
    ` 1. ${i18n.getString(_TL_('Copy the snippet below and paste it in between the <head> and </head> tags of the page(s) you\'d like to track, right after the base UET tag.'))}`,
    ` 2. ${i18n.getString(_TL_('Call the function "uet_report_conversion" when the specific action is taken i.e. button or URL is clicked.'))}`,
    // Keep the next line as a separate item in array, will be removed if being rendered for downloading instructions.
    i18n.getString(_TL_('You can also {{a}}{{/a}} if not sure how to do it manually.')),
  ],
  PageLoadEventTagInstructions: [
    i18n.getString(_TL_('On each page where this event happens (for example, your order confirmation page or purchase completion page), copy this tag and paste it in between the <head> and </head> tags right after the base UET tag.')),
    // Keep the next line as a separate item in array, will be removed if being rendered for downloading instructions.
    i18n.getString(_TL_('You can also {{a}}{{/a}} if not sure how to do it manually.')),
  ],
  InlineEventTagWithRevenueInstructions: [
    ` 1. ${i18n.getString(_TL_('Copy the snippet below and paste it in between the <head> and </head> tags of the page(s) you\'d like to track, right after the base UET tag.'))}`,
    ` 2. ${i18n.getString(_TL_('Call the function "uet_report_conversion" when the specific action is taken i.e. button or URL is clicked.'))}`,
    ` 3. ${i18n.getString(_TL_('Update the revenue_value parameter with the real revenue value associated with the conversion.'))}`,
    // Keep the next line as a separate item in array, will be removed if being rendered for downloading instructions.
    i18n.getString(_TL_('You can also {{a}}{{/a}} if not sure how to do it manually.')),
  ],
  PageLoadEventTagWithRevenueInstructions: [
    ` 1. ${i18n.getString(_TL_('On each page where this event happens (for example, your order confirmation page or purchase completion page), copy this tag and paste it in between the <head> and </head> tags right after the base UET tag.'))}`,
    ` 2. ${i18n.getString(_TL_('Update the revenue_value parameter with the real revenue value associated with the conversion.'))}`,
    // Keep the next line as a separate item in array, will be removed if being rendered for downloading instructions.
    i18n.getString(_TL_('You can also {{a}}{{/a}} if not sure how to do it manually.')),
  ],

  EnhancedConvCode: [
    '<script>',
    '   // Add this script right after your base UET tag code',
    '   window.uetq = window.uetq || [];',
    "   window.uetq.push('set', { 'pid': { ",
    "      'em': 'contoso@example.com', // Replace with the variable that holds the user's email address. ",
    "      'ph': '+14250000000', // Replace with the variable that holds the user's phone number. ",
    '   } });',
    '</script>',
  ],

  EnhancedConvInstructions: [
    ` 1. ${i18n.getString(_TL_('{{b}}Implement the script.{{/b}} Copy the code snippet below and paste it in between the <head> and </head> tags of the page(s) you’d like to track, right after the base UET tag.'))}`,
    ` 2. ${i18n.getString(_TL_('{{b}}Standardize the data.{{/b}} For the privacy of your customers, the personal customer data in your file (email addresses) must be encrypted or hashed. To standardize the hash results, please follow the formatting rules below before hashing.'))}`,
    '{{hashingInstructions}}{{/hashingInstructions}}',
    ` 3. ${i18n.getString(_TL_('{{b}}(Optional) Hash the data.{{/b}} If we detect that personal customer data is not hashed, we will hash it before we collect it. You can also hash this data yourself using the SHA-256 algorithm.'))}`,

    i18n.getString(_TL_('You can also {{a}}{{/a}} if not sure how to do it manually.')),
  ],

  HashingInstructions: [
    `${i18n.getString(_TL_('Format phone numbers according to the {{e164}}E.164 standard{{/e164}}'))}`,
    `${i18n.getString(_TL_('For email:'))}`,
    `${i18n.getString(_TL_('Remove all whitespaces and accents (ex: à) from the email address '))}`,
    `${i18n.getString(_TL_('Remove everything between “+” and “@” (e.g. name+withplus@outlook.com becomes name@outlook.com)  '))}`,
    `${i18n.getString(_TL_('Remove any periods that come before “@” and make sure it doesn’t end with a period (e.g. ex.ample@outlook.com. becomes example@outlook.com) '))}`,
    `${i18n.getString(_TL_('Make sure the text is in lower case and that the email address contains “@” sign'))}`,
  ],
});
